import Gateway from '../Gateway';

export default class CounterState {
  static get name() {
    return 'session_was_counted';
  }

  static wasUpdated() {
    return !!Gateway.window.sessionStorage.getItem(this.name);
  }

  static lock() {
    return Gateway.window.sessionStorage.setItem(this.name, '1');
  }

  static get _defaultValue() {
    return false;
  }
}
